import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import {
  FaLinkedin,
  FaGithub,
  FaWhatsapp,
  FaEnvelope,
  FaCheckCircle,
  FaPaperPlane,
} from 'react-icons/fa';
import './Contact.css';

const socialLinks = [
  {
    icon: <FaLinkedin />,
    label: 'LinkedIn',
    handle: '/in/bernardo-netto',
    href: 'https://www.linkedin.com/in/bernardo-netto/',
  },
  {
    icon: <FaGithub />,
    label: 'GitHub',
    handle: '@sl4k3r1',
    href: 'https://github.com/sl4k3r1',
  },
  {
    icon: <FaWhatsapp />,
    label: 'WhatsApp',
    handle: 'Conversar agora',
    href: 'https://wa.me/5551995620737',
  },
];

const Contact = () => {
  const [state, handleSubmit] = useForm('xzzpgbbw');

  return (
    <section id="contact" className="section reveal">
      <div className="section-header">
        <h2 className="section-title">Contato</h2>
        <span className="section-subtitle">
          Vamos conversar sobre o seu próximo projeto?
        </span>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <h3>
            <FaEnvelope /> Fale comigo
          </h3>
          <p>
            Estou disponível para freelas, oportunidades e parcerias.
            Responda em até 24 horas em qualquer um dos canais abaixo.
          </p>

          <div className="social-links">
            {socialLinks.map((social, idx) => (
              <a
                key={idx}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <span className="social-icon">{social.icon}</span>
                <span className="social-text">
                  <span className="social-label">{social.label}</span>
                  <span className="social-handle">{social.handle}</span>
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="contact-form-wrapper">
          {state.succeeded ? (
            <div className="contact-success">
              <FaCheckCircle />
              <h3>Mensagem enviada!</h3>
              <p>
                Obrigado pelo contato. Vou te responder o mais rápido
                possível.
              </p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nome</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Seu nome completo"
                  required
                />
                <ValidationError
                  prefix="Nome"
                  field="name"
                  errors={state.errors}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="seu@email.com"
                  required
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Como posso te ajudar?"
                  required
                />
                <ValidationError
                  prefix="Mensagem"
                  field="message"
                  errors={state.errors}
                />
              </div>

              <button
                type="submit"
                disabled={state.submitting}
                className="contact-submit"
              >
                {state.submitting ? (
                  'Enviando...'
                ) : (
                  <>
                    Enviar mensagem <FaPaperPlane />
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
